import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { makeDynamicDataLoader } from './factory';

var _makeDynamicDataLoade = makeDynamicDataLoader('msas', function (set, client) {
  return client.msas.getList({
    include_all: 1
  }).then(function (_ref) {
    var msas = _ref.msas;
    return set(msas.reduce(function (acc, msa) {
      return _objectSpread({}, acc, _defineProperty({}, msa.alias, msa.id));
    }, {}));
  });
}),
    getMsaAliasToId = _makeDynamicDataLoade.get,
    loadMsaAliasToId = _makeDynamicDataLoade.load;

export { getMsaAliasToId, loadMsaAliasToId };